import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  ApprovalConfigDetail,
  ApprovalConfigTableDto,
  SaveApprovalConfigPayload,
} from '../../../models/approval/approval-config.model';

@Injectable({ providedIn: 'root' })
export class ApiApprovalConfigService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getApprovalConfigForTable(
    page = 1,
    pageSize = 20,
    menuListId?: number | null,
    enable?: boolean | null
  ): Observable<ApprovalConfigTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number | boolean> = { page, pageSize };
    if (menuListId != null) params['menuListId'] = menuListId;
    if (enable != null) params['enable'] = enable;

    return this.apiMethodService.request<ApprovalConfigTableDto>(
      '/Approval/getApprovalConfigForTable',
      'GET',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'getApprovalConfigForTable', token, headerOnly: false, params }
    );
  }

  getApprovalConfigById(id: number): Observable<ApprovalConfigDetail> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ApprovalConfigDetail>(
      '/Approval/getApprovalConfigById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getApprovalConfigById',
        token,
        headerOnly: false,
        params: { id },
      }
    );
  }

  saveApprovalConfig(payload: SaveApprovalConfigPayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/Approval/saveApprovalConfig',
      'POST',
      this.baseUrl,
      { isConsoleLog: true, labelLog: 'saveApprovalConfig', token, headerOnly: false, body: payload }
    );
  }

  deleteApprovalConfig(id: number, userId: number, menuId: number): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/Approval/deleteApprovalConfig',
      'DELETE',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'deleteApprovalConfig',
        token,
        headerOnly: false,
        params: { id, userId, menuId },
      }
    );
  }
}
